import type { ExposureRow } from "../../contract"
import { Exposure as ExposureTable } from "../../ds"
import { rupees } from "./money"

/** What it could cost (Results-v4 04): one row per outcome, the total, interest still running. */
export function Exposure({ rows, total, monthly, note }: {
  rows: ExposureRow[]
  total?: ExposureRow | null
  monthly?: number | null
  note?: string
}) {
  // With no amounts at all, a table of words helps nobody: say it as prose (Exposure README).
  if (rows.every((r) => r.amount_inr === null || r.amount_inr === undefined)) {
    return (
      <ul className="aexp-prose">
        {rows.map((r, i) => <li key={i}>{r.label}{r.note ? `: ${r.note}` : ""}</li>)}
        {note ? <li className="note">{note}</li> : null}
      </ul>
    )
  }
  const row = (r: ExposureRow) => ({ label: r.label, basis: r.note || "", amount: rupees(r.amount_inr) })
  const notes = [monthly ? `Interest grows about ${rupees(monthly)} a month while the demand stands.` : "", note || ""]
    .filter(Boolean)
    .join(" ")
  return (
    <ExposureTable
      className="aexp"
      rows={rows.map(row)}
      total={total ? row(total) : undefined}
      note={notes || undefined}
      headLabel="If"
      headBasis="How"
    />
  )
}
